<template>
  <v-dialog v-model="show" persistent scrollable :max-width="$spec.dialog_standard_max_width">
    <v-card>
      <v-card-title class="headline">新增健檢報告</v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-select
            v-model="doctor"
            :items="doctorItems"
            label="主治醫師"
            item-text="name"
            item-value="phone"
          ></v-select>
          <base-date-picker appendIcon="mdi-calendar-month" label="健檢日期" ref="datePicker"></base-date-picker>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="show = false">取消</v-btn>
        <v-btn color="green" text @click="createReport" :loading="loading">建立</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import BaseDatePicker from "../common/BaseDatePicker";

export default {
  props: ["pet", "petId"],
  components: {
    BaseDatePicker
  },
  data: thisVm => ({
    show: false,
    loading: false,
    doctorItems: [],
    doctors: {},
    doctor: thisVm.$my.getPhone()
  }),
  methods: {
    showDialog() {
      this.loading = false;
      this.show = true;
    },
    async getStaff() {
      let response = await this.$ajax.post(
        `${this.$config.apiUrl}/${this.$my.getClinic()}/search/user`,
        { permission: "role_admin" }
      );
      response.data.forEach(staff => {
        this.doctors[staff.phone] = staff.name;
        this.doctorItems.push({ name: staff.name, phone: staff.phone });
      });

      response = await this.$ajax.post(
        `${this.$config.apiUrl}/${this.$my.getClinic()}/search/user`,
        { permission: "role_staff" }
      );
      response.data.forEach(staff => {
        this.doctors[staff.phone] = staff.name;
        this.doctorItems.push({ name: staff.name, phone: staff.phone });
      });
      //console.log("response:" + JSON.stringify(response.data));
    },
    async createReport() {
      this.loading = true;

      await this.$ajax.post(
        `${this.$config.apiUrl}/${this.$my.getClinic()}/reports/`,
        {
          clinic: this.$my.getClinic(),
          date: this.$refs.datePicker.getDate(),
          doctor: this.doctors[this.doctor],
          name: this.pet.userName,
          phone: this.pet.userPhone,
          petId: this.petId,
          pet: {
            name: this.pet.name,
            breed: this.pet.breed,
            gender: this.pet.gender,
            age: this.$common.parsePetAge(this.pet.birth),
            type: this.pet.type
          }
        }
      );
      this.show = false;
      this.loading = false;
      this.$emit("done");
    }
  },
  mounted() {
    this.getStaff();
  }
};
</script>